import { gql } from "graphql-request";

export const UPDATE_CONSENT_QUERY = gql`
    mutation ExecuteUpdateUserConsent($inConsent: Boolean!, $inUserSID: UUID!) {
        executeUpdateUserConsent(inUserSID: $inUserSID, inConsent: $inConsent) {
            UserSID
            Consent
        }
    }
`;

export const GET_USER_INFO = gql`
    query ExecuteGetUser($inUserSID: UUID!) {
        executeGetUser(inUserSID: $inUserSID) {
            UserSID
            DateCreated
            UserName
            UserSID
            Jurisdiction
            Consent
        }
    }
`;
